import StudentPersonalSsciPage from "./StudentPersonalSsciPage";
export default StudentPersonalSsciPage;